module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"inactive":"Off","active":"On"},"ru":{"inactive":"Выкл","active":"Вкл"},"ua":{"inactive":"Викл","active":"Вкл"}}')
  delete Component.options._Ctor
}
